import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../../agents/angular/models/agent.model";
import {
  PlanningProjectDraftSelectListComponent
} from "../../../planning/angular/components/planning-project-draft-select-list/planning-project-draft-select-list.component";
import {
  ScheduleAvailabilityApprovalDialogComponent
} from "../../angular/components/schedule-availability-approval-dialog/schedule-availability-approval-dialog.component";
import {ScheduleType} from "../../types/schedule.type";

export class ScheduleApprovalTableRowComponent implements IController {
  agent: AgentModel;
  schedule: any;
  onApprove: Function;
  onReject: Function;
  onEdit: Function;

  public scheduleType: typeof ScheduleType = ScheduleType;

  /* @ngInject */
  constructor(private panelService) {

  }

  $onInit() {

  }

  $onChanges(changes) {

  };

  onShowPanel(event) {
    const panel = this.panelService.open(ScheduleAvailabilityApprovalDialogComponent, event, {
      agent: this.agent,
      agentSchedule: this.schedule.agentSchedule
    }, {
      width: 300,
      height: 300
    })

    if (panel) {
      panel.afterClose$.subscribe((data?: { approved: boolean }) => {
        if (data) {
          if (data.approved) {
            this.onApprove();
          } else {
            this.onReject();
          }
        }
      })
    }

  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleApprovalTableRow', {
    bindings: {
      agent: '<',
      schedule: '<',
      onApprove: '&',
      onReject: '&',
      onEdit: '&'
    },
    template: require('./schedule-approval-table-row.html').default,
    controller: ScheduleApprovalTableRowComponent
  });
